import React  from 'react';

const SiteSettingsContext = React.createContext();
export default SiteSettingsContext;